import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mobile-menu"
export default class extends Controller {
  static targets = ["menu", "overlay"]

  toggle() {
    if (!this.hasMenuTarget) return

    const isHidden = this.menuTarget.classList.contains("hidden")

    if (isHidden) {
      this.menuTarget.classList.remove("hidden")
      if (this.hasOverlayTarget) this.overlayTarget.classList.remove("hidden")
      if (this.hasOverlayTarget) document.body.style.overflow = "hidden"
    } else {
      this.menuTarget.classList.add("hidden")
      if (this.hasOverlayTarget) this.overlayTarget.classList.add("hidden")
      document.body.style.overflow = ""
    }
  }
}

